import { setActiveItemInputKeys } from '../../../State/activeItemInputKeys';
import sanitiseValuationItemPercentage from '../../../Services/sanitiseValuationItemPercentage';

export default ({ orderIndex, orderGroupIndex, orderItemIndex }) => async (dispatch) => {
  
  dispatch(setActiveItemInputKeys(null));
  dispatch(sanitiseValuationItemPercentage({ orderIndex, orderGroupIndex, orderItemIndex }));

}